exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-card-validation-face-component .card-detail-image:not(:first-child){margin-top:1.4rem}.tab-card-validation-face-component .card-detail-image .col-img{text-align:center;max-width:220px;padding-right:0}.tab-card-validation-face-component .card-detail-image .col-img img{width:160px;margin:10px 0 0 0}.tab-card-validation-face-component .content-load-more-items{margin-top:1.4rem}.tab-card-validation-face-component .content-load-more-items .buttons{text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);

// exports
